import { FuelTypeEnum } from '@insurance/api/requests'
import { Select, SelectProps } from 'antd'
import { useTranslation } from 'react-i18next'

import { formProps } from './utils'

export const VehicleFuelSelect = (props: SelectProps) => {
  const { t } = useTranslation()
  const { vehicleFuelProps } = formProps(t)

  const options = Object.values(FuelTypeEnum).map((value) => ({
    label: t(value),
    value
  }))

  return (
    <Select placeholder={vehicleFuelProps.label} options={options} {...props} />
  )
}
